import { useEffect, useState } from "react";
import { Typography, Paper, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useDispatch, useSelector } from "react-redux";
import { updateSection } from "../../../store/Profiles/profilesSlice";
import RowADLS from "../Tables/Row/RowADLS";
import InputBasic from "../ProfilesComp/InputsBasic";

const StepADL = ({ onBack, onNext }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const storedData = useSelector(state => state.profiles.Adl);

    const [adlData, setAdlData] = useState({
        AbilitytoAmbulate: { need: "", type: "", source: "" },
        AbilitytoTransferSelf: { need: "", type: "", source: "" },
        AbilitytoFeedSelf: { need: "", type: "", source: "" },
        AbilitytoToilet: { need: "", type: "", source: "" },
        AbilitytoBatheSelf: { need: "", type: "", source: "" },
        AbilitytoGroomSelf: { need: "", type: "", source: "" },
        AbilitytoDressSelf: { need: "", type: "", source: "" },
        WhatdoestheClientdo: "",
    });

    useEffect(() => {
        setAdlData(() => ({
            ...storedData
        }));
    }, [storedData]);

    const handleNextStep = async () => {
        await handleSaveData(); // 🔹 Espera que termine antes de seguir
        onNext();
    };

    const handleSaveData = async () => {
      dispatch(updateSection({ section: "Adl", data: { Adl:adlData } }));
    }

      
    const handleChange = async(field, value) => {
        setAdlData((prevData) => ({
            ...prevData,
            [field]: value
        }));
    };

    const updateTableFinancial = async ({fieldV, adlsDataRow}) => {
        await handleChange(fieldV, adlsDataRow); // 🔹 Espera que termine antes de seguir
    };

    return (
        <>
            <Typography variant="h5" gutterBottom>{t("Profiles.ADL’s/IADLs.ADL’s/IADLs")}</Typography>
            <Typography variant="h6" gutterBottom>{t("Profiles.ADL’s/IADLs.Describeclient’sability")}</Typography>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t("Profiles.ADL’s/IADLs.ActivityofDailyLiving")}</TableCell>
                            <TableCell>{t("Profiles.ADL’s/IADLs.DoesClientNeed")}</TableCell>
                            <TableCell>{t("Profiles.ADL’s/IADLs.TypeofAssistanceNeeded")}</TableCell>
                            <TableCell>{t("Profiles.ADL’s/IADLs.SourceofAssistance")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {[
                            "AbilitytoAmbulate",
                            "AbilitytoTransferSelf",
                            "AbilitytoFeedSelf",
                            "AbilitytoToilet",
                            "AbilitytoBatheSelf",
                            "AbilitytoGroomSelf",
                            "AbilitytoDressSelf"
                        ].map((key, index) => (
                            <RowADLS 
                                key={index}
                                fieldV={ key } 
                                index={index + 1} 
                                Translation={`Profiles.ADL’s/IADLs.${key}`} 
                                updateTableFinancial={ updateTableFinancial } 
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <InputBasic 
                    Translation="Profiles.ADL’s/IADLs.WhatdoestheClientdo" 
                    multiline
                    value={adlData.WhatdoestheClientdo || ""} 
                    rows={6}
                    onChange={(e) => handleChange("WhatdoestheClientdo", e.target.value)}
                />
            </Box>
            {/* Botones */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
                    {t("common.back")}
                </Button>
                <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
                    {t("common.next")}
                </Button>
            </Box>
        </>
    );
};

export default StepADL;
